import { Pipe, PipeTransform } from '@angular/core';
import numWords from 'num-words';

@Pipe({
  name: 'numberToWords'
})
export class NumberToWordsPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    return numWords(value);
  }

}
